import { haptic } from '../utils/haptic';

interface Props {
  urls: string[];
}

/** Tappable URL chip strip for mobile SSH.
 *  When terminal output contains URLs (e.g. oauth flows), renders a horizontal bar of
 *  tap-to-open chips so mobile users don't need to copy/paste long URLs manually.
 *  WebLinksAddon only handles mouse events — this strip covers touch devices.
 */
export function SshLinkBar({ urls }: Props) {
  if (urls.length === 0) return null;

  const open = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
    haptic(30);
  };

  return (
    <div class="ssh-link-bar-container">
      <div class="ssh-link-bar">
        <span class="ssh-link-bar-label">Links:</span>
        {urls.map((url) => (
          <button
            key={url}
            class="ssh-link-chip"
            onClick={() => open(url)}
            title={url}
          >
            ↗ {url.length > 48 ? url.slice(0, 48) + '…' : url}
          </button>
        ))}
      </div>
    </div>
  );
}
